import { render, staticRenderFns } from "./ModalTermsConditions.vue?vue&type=template&id=8092f5e2&"
import script from "./ModalTermsConditions.vue?vue&type=script&lang=js&"
export * from "./ModalTermsConditions.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermsConditions.vue?vue&type=style&index=0&id=8092f5e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports